/// <reference types="@types/googlemaps" />
import { DOCUMENT } from '@angular/common';
import { Component, Inject, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';
import { AddressType } from 'src/app/shared/models/address-detail';
@Component({
  selector: 'address-auto-complete',
  templateUrl: './address-auto-complete.component.html',
  styleUrls: ['./address-auto-complete.component.scss']
})
export class AddressAutoCompleteComponent implements OnInit {
  @Input() addressType!: AddressType | AddressType.address;
  @Input() placeholder!: string | "Enter Address";
  @Input() tagId!: string;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();

  readonly googleMapsScript: string = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${this.configService.config.googleKey}`;
  readonly googleMapsScriptId: string = `google-maps-api-script`;

  autocompleteInput!: string | '';
  queryWait!: boolean | false;
  hasUpdatedSinceLastFocus: boolean = false;

  constructor(private configService: ConfigService,
    @Inject(DOCUMENT) private document: any,
    private renderer: Renderer2) { }

  ngOnInit(): void {
    this.appendScript().then(() => this.getPlaceAutocomplete());
  }

  appendScript() {
    let promise = new Promise((resolve, reject) => {
      if (document.getElementById(this.googleMapsScriptId) === null) {
        let scriptElement = this.renderer.createElement("script");
        scriptElement.id = this.googleMapsScriptId;
        scriptElement.type = "text/javascript";
        scriptElement.src = this.googleMapsScript;
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.onload = resolve;
        scriptElement.onerror = reject;

        this.renderer.appendChild(this.document.body, scriptElement);
      } else {
        let scriptElement = document.getElementById(this.googleMapsScriptId);
        if (scriptElement) {
          scriptElement.addEventListener('load', () => {
            resolve({ loaded: true, status: 'Script Loaded' });
          });
          scriptElement.addEventListener('error', () => {
            reject({ loaded: false, status: 'Script Failed' });
          });
        }
      }
    });

    return promise;
  }

  getPlaceAutocomplete() {
    let addressType = this.getAddressType();
    let options = {
      componentRestrictions: { country: 'AU' },
      types: [addressType],
      fields: ["name", "address_components"],
    } as google.maps.places.AutocompleteOptions;

    if (this.addressType !== AddressType.any) {
      delete options.types;
    }

    let inputTag = document.getElementById(this.tagId)?.getElementsByTagName("input")[0];

    if (inputTag == null) {
      throw new Error(`Input tag '${this.tagId}' does not exist`);
    }

    const autocomplete = new google.maps.places.Autocomplete(inputTag as HTMLInputElement, options);

    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place: google.maps.places.PlaceResult = autocomplete.getPlace();
      this.invokeEvent(place);
    });
  }

  onPostalAddressEnterKeyDown(event: KeyboardEvent) {
    event.preventDefault();
  }

  onChange() {
    this.autocompleteInput = '';
    const place = { name: '' } as google.maps.places.PlaceResult;
    this.setAddress.emit(place);
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }

  getAddressType(): string {
    var addressType: string = "";

    switch (Number(this.addressType)) {
      case AddressType.address:
        addressType = "address";
        break;
      case AddressType.establishment:
        addressType = "establishment";
        break;
      case AddressType.geocode:
        addressType = "geocode";
        break;
    }

    return addressType;
  }
}
